import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { NbAuthService, NbTokenService } from '@nebular/auth';
import { combineLatest} from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private auth: NbAuthService, private token: NbTokenService) {}

  /**
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return combineLatest([this.auth.isAuthenticated(), this.token.get()]).pipe(
      switchMap(([authenticated, token]) => {
        return authenticated
          ? next.handle(TokenInterceptor.handleTokenHeader(request, token.getValue()))
          : next.handle(request);
      })
    )
  }

  /**
   * Append Authentication header.
   * @param req
   * @param token
   * @private
   */
  private static handleTokenHeader(req: HttpRequest<any>, token: string) {
      return token ?
        req.clone({
          headers: req.headers.append('Authorization', `Bearer ${token}`),
        }) : req;
  }
}
